// extracted by mini-css-extract-plugin
module.exports = {"row":"_4f720283bf--row--1GivK","divider":"_4f720283bf--divider--Bgccx","right-block":"_4f720283bf--right-block--vhRQQ"};